<template>
  <div class="logo_container">
    <div class="columns">
      <div class="column">
        <h1 class="title">{{title}}</h1>
      </div>
      <div class="column referralCode">
        <img src="/static/img/referral.png" style="max-width: 87px;"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'hero-header',
    data() {
      return {
        title: '',
      };
    },
    mounted() {
      const messages = [
        'A referral a week might just pay for the holidays in Mozambique.',
        'You would like to see your friends more often? Bring them to work every day!',
        'Wanna pay your holiday, make a referral every day.',
      ];
      this.title = messages[0];
      let i = 0;
      this.timer = setInterval(() => {
        i += 1;
        if (i >= 3) {
          i = 0;
        }
        this.title = messages[i];
      }, 5000);
    },
  };
</script>

<style scoped lang="scss">
@import '../../styles/variables';

  div.logo_container {
    background: $tamedia_grey;
    margin: 5px 0 -1rem 2rem;
    color: $tamedia_grey3;
  }
.referralCode {
  margin: 1px 0px -1rem 2rem;
}

  .title, .subtitle {
    color: $tamedia_grey3;
  }

</style>



// WEBPACK FOOTER //
// src/components/jobs/HeroHeader.vue